import { ConsoleLogger } from './logger.js';
import { validateName } from './utils.js';
import { DNSModule } from './dns/dns-module.js';
import { InMemoryCache } from './cache.js';
export class DNSConnect {
    #logger;
    #cache;
    #modules;
    constructor(options) {
        if (options && typeof options !== 'object')
            throw new Error('Options must be an object.');
        this.#logger = options?.logger ?? new ConsoleLogger(options?.logLevel ?? 'info');
        const cachingEnabled = options?.caching?.enabled ?? true;
        if (cachingEnabled) {
            this.#cache = options?.caching?.cacheProvider ?? new InMemoryCache();
        }
        this.#modules = options?.modules ?? [];
        // DNS Resolution module always takes priority
        this.#modules.unshift(new DNSModule(options?.dns, this.#logger, this.#cache));
    }
    async resolve(name, network) {
        if (!name)
            throw new Error('Name is required.');
        validateName(name);
        if (!network)
            throw new Error('Network is required');
        if (typeof network !== 'string')
            throw new Error('Network is not a string.');
        const cacheKey = `${name}:${network}`;
        const cachedAddress = await this.#cache?.get(cacheKey);
        if (cachedAddress) {
            this.#logger.info(`Returning cached address for ${name} on ${network}: ${cachedAddress}.`);
            return cachedAddress;
        }
        for (const module of this.#modules) {
            this.#logger.info(`Resolving ${name} on ${network} using ${module.name} module.`);
            const resolvedAddress = await module.resolve(name, network);
            if (resolvedAddress) {
                this.#logger.info(`${module.name} module resolution successful. Resolved address: ${resolvedAddress.address}. TTL: ${resolvedAddress.ttl}.`);
                if (resolvedAddress.ttl && resolvedAddress.ttl > 0 && this.#cache) {
                    this.#logger.info(`Caching ${name} on ${network} for ${resolvedAddress.ttl} seconds.`);
                    await this.#cache.set(cacheKey, resolvedAddress.address, resolvedAddress.ttl);
                }
                return resolvedAddress.address;
            }
            else {
                this.#logger.info(`${module.name} module resolution failed.`);
            }
        }
    }
    async reverseResolve(address, network) {
        const cacheKey = `${address}:${network}`;
        const cachedDomain = await this.#cache?.get(cacheKey);
        if (cachedDomain) {
            return cachedDomain;
        }
        for (const module of this.#modules) {
            const resolvedDomain = await module.reverseResolve(address, network);
            if (resolvedDomain) {
                if (resolvedDomain.ttl && resolvedDomain.ttl > 0 && this.#cache) {
                    await this.#cache.set(cacheKey, resolvedDomain.name, resolvedDomain.ttl);
                }
                return resolvedDomain.name;
            }
        }
    }
}
//# sourceMappingURL=dns-connect.js.map